var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGitHubSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 12,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 .14a6 6 0 0 0-1.86 11.705h.14a.5.5 0 0 0 .486-.305.5.5 0 0 0 .044-.225v-.65a.25.25 0 0 0-.095-.165.25.25 0 0 0-.205-.05c-1.345.29-1.63-.55-1.645-.605A2.3 2.3 0 0 0 2 8.75l-.075-.055a.37.37 0 0 1 .19-.035.74.74 0 0 1 .57.44 1.5 1.5 0 0 0 2 .58.27.27 0 0 0 .15-.18 1 1 0 0 1 .28-.61.25.25 0 0 0 .075-.265.25.25 0 0 0-.21-.175c-1.185-.135-2.4-.55-2.4-2.595a2 2 0 0 1 .53-1.39.25.25 0 0 0 .045-.26A1.78 1.78 0 0 1 3.16 3c.462.083.895.28 1.26.575a.24.24 0 0 0 .21.03 5.33 5.33 0 0 1 2.745 0 .23.23 0 0 0 .205-.03A2.77 2.77 0 0 1 8.84 3a1.77 1.77 0 0 1 0 1.19.24.24 0 0 0 .05.26 2 2 0 0 1 .525 1.375c0 2.05-1.215 2.46-2.405 2.59a.25.25 0 0 0-.21.175.25.25 0 0 0 .075.26 1.12 1.12 0 0 1 .305.875v1.59a.53.53 0 0 0 .185.41.59.59 0 0 0 .53.095A6 6 0 0 0 6 .14"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 12,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 .14a6 6 0 0 0-1.86 11.705h.14a.5.5 0 0 0 .486-.305.5.5 0 0 0 .044-.225v-.65a.25.25 0 0 0-.095-.165.25.25 0 0 0-.205-.05c-1.345.29-1.63-.55-1.645-.605A2.3 2.3 0 0 0 2 8.75l-.075-.055a.37.37 0 0 1 .19-.035.74.74 0 0 1 .57.44 1.5 1.5 0 0 0 2 .58.27.27 0 0 0 .15-.18 1 1 0 0 1 .28-.61.25.25 0 0 0 .075-.265.25.25 0 0 0-.21-.175c-1.185-.135-2.4-.55-2.4-2.595a2 2 0 0 1 .53-1.39.25.25 0 0 0 .045-.26A1.78 1.78 0 0 1 3.16 3c.462.083.895.28 1.26.575a.24.24 0 0 0 .21.03 5.33 5.33 0 0 1 2.745 0 .23.23 0 0 0 .205-.03A2.77 2.77 0 0 1 8.84 3a1.77 1.77 0 0 1 0 1.19.24.24 0 0 0 .05.26 2 2 0 0 1 .525 1.375c0 2.05-1.215 2.46-2.405 2.59a.25.25 0 0 0-.21.175.25.25 0 0 0 .075.26 1.12 1.12 0 0 1 .305.875v1.59a.53.53 0 0 0 .185.41.59.59 0 0 0 .53.095A6 6 0 0 0 6 .14"
  })));
});
export default SvgIconGitHubSolid;
export const raw = __webpack_public_path__ + "static/media/IconGitHubSolid.f18b8f1d05ebe504f8dea303175e456b.svg";